// extracted by mini-css-extract-plugin
export default {"askQuestionTopText":"C5-z","yourQuestionLabel":"D5-z","notAuthedMessage":"E5-z","form":"F5-z","textarea":"G5-z","error":"H5-z","disabled":"I5-z","edited":"J5-z","submit":"K5-z"};